import {
  SHOW_RESTRICTIONS_MODAL,
  SHOW_RESTRICTIONS_MODAL_HIDE
} from 'Redux/actionTypes';

export const showRestrictionsModal = (data, settings, model2) => ({
  type: SHOW_RESTRICTIONS_MODAL,
  payload: { data, settings, model2 }
});

export const showRestrictionsHide = () => ({
  type: SHOW_RESTRICTIONS_MODAL_HIDE,
  payload: {}
});